import { Link } from "react-router-dom";
import { ArrowRight, CalendarCheck } from "@phosphor-icons/react";
import { trackSiteEvent } from "../lib/analytics";

// Compact homepage introduction to the Request-a-Truck flow.
// The /find-a-truck page itself carries the full pitch.
export default function EventRequestBanner() {
  return (
    <section
      className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pb-16"
      data-testid="event-request-banner"
    >
      <div className="rounded-2xl border border-orange-500/30 bg-gradient-to-r from-orange-500/10 via-card to-card p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <span className="h-10 w-10 rounded-xl bg-orange-500/15 text-orange-600 dark:text-orange-400 grid place-items-center flex-none">
            <CalendarCheck weight="duotone" className="h-5 w-5" />
          </span>
          <div className="min-w-0">
            <h2 className="font-display font-bold text-base md:text-lg tracking-tight">
              Planning an event?
            </h2>
            <p className="text-sm text-muted-foreground">
              Find available local food trucks with one request — free for hosts.
            </p>
          </div>
        </div>
        <Link
          to="/find-a-truck"
          onClick={() => trackSiteEvent("cta_request_truck")}
          className="inline-flex items-center justify-center gap-1.5 h-11 px-5 rounded-full bg-primary text-primary-foreground font-semibold text-sm hover:bg-primary/90 transition-colors flex-none"
          data-testid="event-banner-cta"
        >
          Request a food truck
          <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </section>
  );
}
